import { NotificationType, UserRole } from 'services/api/api-client.types.ts';

export enum PageName {
  WelcomePage = 'WelcomePage',
  AdminPage = 'AdminPage',
  ArticlesPage = 'ArticlesPage',
  FirmwareOldPage = 'FirmwareOldPage',
  DeliveryObligationPage = 'DeliveryObligationPage',
  DruckdatenPage = 'DruckdatenPage',
  DesignerRootPage = 'DesignerRootPage',
  DesignerNewPage = 'DesignerNewPage',
  DesignerSinglePage = 'DesignerSinglePage',
  WarrantyRequestPage = 'WarrantyRequestPage',
  WarrantyRequestHistoryPage = 'WarrantyRequestHistoryPage',
  QualificationsPage = 'QualificationsPage',
  DeviceOverviewPage = 'DeviceOverviewPage',
  UserManagementPage = 'UserManagementPage',
  OrderListPage = 'OrderListPage',
  OutstandingReceivablesPage = 'OutstandingReceivablesPage',
  CreateRepairRequestPage = 'CreateRepairRequestPage',
  DetailedRepairsPage = 'DetailedRepairsPage',
  RepairsPage = 'RepairsPage',
  ServiceAndRepairPage = 'ServiceAndRepairPage',
  TelehealthBillingPage = 'TelehealthBillingPage',
  PriceListsPage = 'PriceListsPage',
  ServicePresentationPage = 'ServicePresentationPage',
  TechUpdatesPage = 'TechUpdatesPage',
  AbasDocumentsPage = 'AbasDocumentsPage',
  MainboardReplacerFormPage = 'MainboardReplacerFormPage',
  AdvancedSearchPage = 'AdvancedSearchPage',
  CertificateInstructionPage = 'CertificateInstructionPage',
  AccountSettings = 'AccountSettings',
  SNLotsPage = 'SNLotsPage',
  FirmwareNotifications = 'FirmwareNotifications',
}

export const all = 'all';
export type AllowedRolesValue = UserRole[] | typeof all;

export const AllowedRoles: Record<PageName, AllowedRolesValue> = {
  WelcomePage: all,
  AdminPage: [UserRole.Admin, UserRole.SemiAdmin],
  ArticlesPage: [UserRole.Admin, UserRole.Supplier],
  FirmwareOldPage: [UserRole.Admin],
  DeliveryObligationPage: [UserRole.Admin, UserRole.Supplier],
  DruckdatenPage: [UserRole.Admin, UserRole.Supplier],
  DesignerRootPage: [UserRole.Admin],
  DesignerNewPage: [UserRole.Admin],
  DesignerSinglePage: [UserRole.Admin],
  WarrantyRequestPage: [UserRole.Garantie, UserRole.Admin, UserRole.TechnikerE],
  WarrantyRequestHistoryPage: [
    UserRole.Garantie,
    UserRole.Admin,
    UserRole.TechnikerE,
  ],
  QualificationsPage: [
    UserRole.Admin,
    UserRole.Customer,
    UserRole.Garantie,
    UserRole.Standard,
    UserRole.Techniker,
    UserRole.TechnikerE,
    UserRole.HaendlerDe,
    UserRole.HaendlerEk,
  ],
  DeviceOverviewPage: [
    UserRole.Admin,
    UserRole.Customer,
    UserRole.Garantie,
    UserRole.Standard,
    UserRole.Techniker,
    UserRole.Techniker2,
    UserRole.TechnikerE,
  ],
  UserManagementPage: [UserRole.Admin, UserRole.SemiAdmin],
  OrderListPage: [
    UserRole.Admin,
    UserRole.Customer,
    UserRole.Garantie,
    UserRole.Standard,
  ],
  OutstandingReceivablesPage: [
    UserRole.Admin,
    UserRole.Customer,
    UserRole.Garantie,
    UserRole.Standard,
  ],
  CreateRepairRequestPage: [
    UserRole.Admin,
    UserRole.Customer,
    UserRole.Garantie,
    UserRole.Standard,
    UserRole.Techniker,
    UserRole.Techniker2,
    UserRole.TechnikerE,
  ],
  DetailedRepairsPage: [
    UserRole.Admin,
    UserRole.Customer,
    UserRole.Garantie,
    UserRole.Standard,
    UserRole.Techniker,
    UserRole.Techniker2,
    UserRole.TechnikerE,
  ],
  RepairsPage: [
    UserRole.Admin,
    UserRole.Customer,
    UserRole.Garantie,
    UserRole.Standard,
    UserRole.Techniker,
    UserRole.Techniker2,
    UserRole.TechnikerE,
  ],
  ServiceAndRepairPage: [
    UserRole.Admin,
    UserRole.Customer,
    UserRole.Garantie,
    UserRole.Standard,
    UserRole.Techniker,
    UserRole.Techniker2,
    UserRole.TechnikerE,
    UserRole.HaendlerDe,
    UserRole.HaendlerEk,
  ],
  TelehealthBillingPage: [
    UserRole.Admin,
    UserRole.Customer,
    UserRole.Garantie,
    UserRole.Standard,
    UserRole.Toechter,
  ],
  PriceListsPage: [
    UserRole.Admin,
    UserRole.Customer,
    UserRole.Garantie,
    UserRole.Standard,
    UserRole.Toechter,
    UserRole.HaendlerEk,
  ],
  ServicePresentationPage: [
    UserRole.Admin,
    UserRole.Customer,
    UserRole.Garantie,
    UserRole.Standard,
    UserRole.Techniker,
    UserRole.Techniker2,
    UserRole.TechnikerE,
    UserRole.HaendlerDe,
    UserRole.HaendlerEk,
  ],
  TechUpdatesPage: [
    UserRole.Admin,
    UserRole.Customer,
    UserRole.Garantie,
    UserRole.Standard,
    UserRole.Techniker,
    UserRole.Techniker2,
    UserRole.TechnikerE,
    UserRole.HaendlerDe,
    UserRole.HaendlerEk,
  ],
  AbasDocumentsPage: [UserRole.Admin],
  MainboardReplacerFormPage: [UserRole.Admin, UserRole.ClevelandAccess],
  CertificateInstructionPage: [UserRole.Admin, UserRole.ClevelandAccess],
  AccountSettings: all,
  AdvancedSearchPage: all,
  SNLotsPage: all,
  FirmwareNotifications: [
    UserRole.Admin,
    UserRole.Customer,
    UserRole.Garantie,
    UserRole.Standard,
    UserRole.Techniker,
    UserRole.Techniker2,
    UserRole.TechnikerE,
    UserRole.HaendlerDe,
    UserRole.HaendlerEk,
    UserRole.SemiAdmin,
    UserRole.FirmwareAccess,
    UserRole.SoftwareAccess,
  ],
};

export const NotificationAllowedPages: Partial<
  Record<NotificationType, PageName>
> = {
  [NotificationType.Firmware]: PageName.FirmwareNotifications,
  [NotificationType.Qualifications]: PageName.QualificationsPage,
  [NotificationType.Repairs]: PageName.RepairsPage,
  [NotificationType.WarrantyRequests]: PageName.WarrantyRequestPage,
};
